<div class="container-fluid m-0 p-0" *ngIf="checkDataExist() && !showLoader">
    <div class="row">
        <div class="col-12 mt-4">
            <div class="border-bottom font-16 mb-3 text-bold">{{ "TAB_MEDICAL_CHECH" | translate | titlecase }}</div>
        </div>
        <div class="col-12">
            <div class="row m-0 p-3 bg-light-grey">
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "MEDICAL_CHECK_STATUS" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.medicalStatus }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "MEDICAL_CHECK_COMMENT" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.medicalComment }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "MEDICAL_CHECK_DATE" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.medicalDate  | date:'yyyy-MM-dd'}}</p>
                </div>
                <br/> <br/>
                <div class="col-md-12 mb-2" >
                    <hr/>
                  </div>
                
                <br/> <br/>
                <div class="col-md-12 mb-2">
                    <label class="cand-diseases"> {{ "CHRONIC_DISEASES" | translate | titlecase }}</label>
                    
                </div>
                <br/>
                <div class="col-md-4 mb-2" *ngFor="let diseases of diseasesData">
                    <label class="text-bold font-14">{{
                        (globals.lang == 'ar')? diseases.diseaseDescAr : diseases.diseaseDescEn
                        }}</label>
                    <p class="cand-answer">{{diseases.diseaseRemark  }}</p>
                </div>
                              
    
            </div>
        </div>
    </div>
    </div>
    <app-loader [show]="!checkDataExist()"></app-loader>